<template>
  <div v-if="showFrontendShell" class="app-shell bg-white text-ink">
    <Navbar />
    <Sidenav />
    <main class="app-main">
      <router-view />
    </main>
    <Footer />
  </div>
  <div v-else-if="showUserShell" class="user-shell bg-white text-ink">
    <UserNavbar />
    <main class="user-main">
      <router-view />
    </main>
    <UserFooter />
  </div>
  <router-view v-else />
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import Navbar from '@/components/frontend/Navbar.vue'
import Footer from '@/components/frontend/Footer.vue'
import Sidenav from '@/components/frontend/Sidenav.vue'
import UserNavbar from '@/components/user/AppNavbar.vue'
import UserFooter from '@/components/user/AppFooter.vue'
import userApi from '@/services/user/api'
import vendorApi from '@/services/vendor/api'
import { getAuthRole, getAuthUserId, isAuthenticated, setAuthSession, setAuthUser } from '@/services/auth'

const route = useRoute()
const showFrontendShell = computed(() => route.meta.layout === 'frontend')
const showUserShell = computed(() => route.meta.layout === 'user')

const resolveProfilePayload = (role, accountId) => {
  const payload = new FormData()
  if (role === 'vendor') {
    payload.append('vendor_id', accountId)
  } else {
    payload.append('s_id', accountId)
    payload.append('user_id', accountId)
  }
  return payload
}

const normalizeProfileUser = (data) => data?.user || data?.data?.user || data?.data || data?.profile || null

const loadProfile = async () => {
  if (!isAuthenticated()) return
  const accountId = getAuthUserId()
  const role = getAuthRole() || 'user'
  if (!accountId) return
  try {
    const payload = resolveProfilePayload(role, accountId)
    const { data } =
      role === 'vendor'
        ? await vendorApi.getProfileVendor(payload)
        : await userApi.getProfile(payload)
    const user = normalizeProfileUser(data)
    if (user) {
      setAuthUser({
        ...user,
        s_id:
          user?.s_id ||
          user?.id ||
          user?.user_id ||
          user?.vendor_id ||
          user?.vendorId ||
          accountId,
        role
      })
      setAuthSession({
        loggedIn: true,
        role,
        s_id:
          user?.s_id ||
          user?.id ||
          user?.user_id ||
          user?.vendor_id ||
          user?.vendorId ||
          accountId
      })
    }
  } catch {
    // ignore profile load failures
  }
}

watch(() => route.fullPath, loadProfile, { immediate: true })
</script>

<style>
:global(html, body, #app) {
  height: 100%;
} 
 

a:hover {
  text-decoration: none!important;
}
</style>
